export const formatDate = (date: string) => {
    const dateFormatted = new Date(date);
    
    return `${dateFormatted.toLocaleDateString()} @ ${dateFormatted.toLocaleTimeString()}`;
};

/**
 * Converts a string to title case (first letter of each word capitalized, rest lowercase)
 * @param str String to convert to title case
 * @returns String in title case format
 */
export const toTitleCase = (str: string) => {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};